import React, { useState, useContext, useEffect } from "react";
import { Box, Grid, Collapse, IconButton, MenuItem, ListItemText, Checkbox } from '@mui/material'
import { styled } from '@mui/material/styles';
import { Add, Remove } from '@mui/icons-material';
import { mainBlue, mainGray, highlightGray } from "../GlobalUtilities/Styles";
import { StateDropDown, CityDropDown, FilterTypeList, CombmoDropDown, StateCityDropList } from "../GlobalUtilities/DataLists";
import { DataContext } from "../context/DataContext";


const SectionHeader = styled('div')`
    border-bottom: solid 1px ${highlightGray};
`;

const SectionContent = styled('div')`
    padding:'16px';
`;

const FilterHeader = styled('div')`
    color: ${mainBlue};
    text-align: left;
    padding: 10px 0 10px 10px; 
    font-size:1.3em;
`;

const FilterHeaderIcon = styled('div')`
    padding-top:5px;
`;

const FilterMenuItem = styled(MenuItem)`
    color: ${mainGray};
    border-bottom: 1px dotted ${highlightGray};
    padding: 1px 0 1px 10px;
    margin-left:10px;
`;

const FilterCheckbox = styled(Checkbox)`
    color: ${mainGray};
    margin-right:1px;
`;

const FilterMenuItemText = styled(ListItemText)`
    text-align: left;
`;

const JobFilter = ({ title, filterList }) => {
    const { originalJobData, locationFilter, setLocationFilter, stateList, setStateList, setCityList } = useContext(DataContext);
    const [expanded, setExpanded] = useState(false);

    const togglePanel = () => {
        setExpanded(!expanded);
    };

    //Handle the city async when states are defined.
    useEffect(() => {
        if (stateList.length > 0) {
            // Update cityList when stateList changes
            const filteredCities = CityDropDown({ states: stateList.map(x => x.value), data: originalJobData });
            setCityList(filteredCities);
        }
    }, [stateList, originalJobData]);

    const handleChange = (event, option, title) => {
        const { checked } = event.target;
        setLocationFilter(prevState => {

            if (checked) {
                const updatedFilter = [...prevState, { label: title, value: option.value }];

                if (title === 'Country') {
                    //Filter States By Country
                    const filteredStates = StateDropDown({ countries: FilterTypeList({ type: "Country", data: updatedFilter }), data: originalJobData });
                    setStateList(filteredStates);
                    //setCityList(CityDropDown({ states: stateList.map(x => x.value), data: originalJobData }))
                }

                if (title === 'State') {
                    //Filter Cities By State 
                    setCityList(CityDropDown({ states: FilterTypeList({ type: "State", data: updatedFilter }), data: originalJobData }))
                }

                return updatedFilter;

            } else {
                // Remove the selected option based on the value
                const updatedFilter = prevState.filter(selectedOption => selectedOption.value !== option.value);
                setStateList(StateDropDown({ countries: FilterTypeList({ type: "Country", data: updatedFilter }), data: originalJobData }))
                setCityList(CityDropDown({ states: FilterTypeList({ type: "State", data: updatedFilter }), data: originalJobData }))

                //If all filters are empty reset State & City
                if (updatedFilter.length === 0) {
                    setStateList(StateDropDown({ data: originalJobData }))
                    setCityList(CityDropDown({ data: originalJobData }))
                }

                return updatedFilter

            }
        });
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
            <SectionHeader>
                <Grid container>
                    <Grid item xs={11}>
                        <FilterHeader>{title}</FilterHeader>
                    </Grid>
                    <Grid item xs={1}>
                        <FilterHeaderIcon>
                            <IconButton onClick={togglePanel}>
                                {expanded ? <Remove /> : <Add />}
                            </IconButton>
                        </FilterHeaderIcon>
                    </Grid>
                </Grid>
            </SectionHeader>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <SectionContent>
                    {filterList.map((item) => (
                        <FilterMenuItem key={item.label} value={item.label}>
                            <FilterMenuItemText primary={item.label} />
                            <FilterCheckbox checked={locationFilter.some(selectedOption => selectedOption.value === item.value)} onChange={(event) => handleChange(event, item, title)} />
                        </FilterMenuItem>
                    ))}
                </SectionContent>
            </Collapse>
        </Box>
    )
};

export default JobFilter;